import { render, staticRenderFns } from "./AssetPersonsTable.vue?vue&type=template&id=0b3d49e5"
import script from "./AssetPersonsTable.vue?vue&type=script&lang=js"
export * from "./AssetPersonsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports